/**
 * SkipLink Component
 * Allows keyboard users to skip to main content
 * WCAG 2.4.1 - Bypass Blocks
 */

import React from 'react';
import './SkipLink.css';

const SkipLink = ({ targetId = 'main-content', children = 'Skip to main content' }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.tabIndex = -1;
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      className="skip-link"
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default SkipLink;
